import type { ClientInit } from '@sveltejs/kit';

import { baseLocale, defineCustomClientStrategy } from '$lib/paraglide/runtime';

export const init: ClientInit = () => {
	defineCustomClientStrategy('custom-getLocale', {
		getLocale: () => {
			return document.documentElement.lang ?? baseLocale;
		},
		setLocale: (locale) => {
			document.documentElement.lang = locale ?? baseLocale;
		},
	});
};
